import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Layout from "./components/UI/Layout"

import Home from "./components/Home";
import About from "./components/About";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="About" element={<About />} />
        </Route>
      </Routes>
    </Router>
  );
}
